var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_362_5828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 25C5 15.5719 5 10.8579 7.92893 7.92893C10.8579 5 15.5719 5 25 5C34.4281 5 39.1421 5 42.0711 7.92893C45 10.8579 45 15.5719 45 25C45 34.4281 45 39.1421 42.0711 42.0711C39.1421 45 34.4281 45 25 45C15.5719 45 10.8579 45 7.92893 42.0711C5 39.1421 5 34.4281 5 25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0331 21.0417C26.8748 21.0417 26.7165 20.9833 26.5915 20.8583L24.8998 19.1667L23.2081 20.8583C22.9665 21.1 22.5665 21.1 22.3248 20.8583C22.0831 20.6167 22.0831 20.2166 22.3248 19.975L24.4581 17.8417C24.6998 17.6 25.0998 17.6 25.3415 17.8417L27.4748 19.975C27.7165 20.2166 27.7165 20.6167 27.4748 20.8583C27.3498 20.9833 27.1915 21.0417 27.0331 21.0417Z",
    fill: "#4F5762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8999 27.4417C24.5582 27.4417 24.2749 27.1583 24.2749 26.8167V18.3417C24.2749 18 24.5582 17.7167 24.8999 17.7167C25.2416 17.7167 25.5249 18 25.5249 18.3417V26.8167C25.5249 27.1667 25.2416 27.4417 24.8999 27.4417Z",
    fill: "#4F5762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 32.2917C20.7085 32.2917 17.7085 29.2917 17.7085 25C17.7085 24.6583 17.9918 24.375 18.3335 24.375C18.6752 24.375 18.9585 24.6583 18.9585 25C18.9585 28.5583 21.4418 31.0417 25.0002 31.0417C28.5585 31.0417 31.0418 28.5583 31.0418 25C31.0418 24.6583 31.3252 24.375 31.6668 24.375C32.0085 24.375 32.2918 24.6583 32.2918 25C32.2918 29.2917 29.2918 32.2917 25.0002 32.2917Z",
    fill: "#4F5762"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_362_5828",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.0235294 0 0 0 0 0.0235294 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_362_5828"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_362_5828",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.7860d8e25f55ecaeaabd53d3a37a237b.svg";
export { ForwardRef as ReactComponent };